module.exports = __webpack_public_path__ + "img/通知.7190b2b4.png";